import React, { useEffect } from "react";
import "./products.css";

import ReactPlayer from "react-player";

import EXM1 from "../../assets/images/products/exm1.jpg";
import EXM2 from "../../assets/images/products/exm2.jpg";
import EXM3 from "../../assets/images/products/exm3.jpg";
import EXM4 from "../../assets/images/products/exm4.jpg";
import EXM5 from "../../assets/images/products/exm5.jpg";

import AOS from "aos";
import "aos/dist/aos.css";

const Examiner = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
  }, []);
  return (
    <>
      <div className="products-banner examiner">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="content">
            <div className="heading" data-aos="fade-up" data-aos-duration="1500">
              <div className="heading-flex">
                <h2>The Examiner</h2>
                <h4>
                  An examination and evaluation platform The Fidus Examiner is a
                  one stop solution for managing assessments/exams both offline
                  and online.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="products-section">
        <div className="products-banner-circle"></div>
        <div className="products-section-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-right" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Insightful Learner and Examiner Dashboards</h2>
                    <p>
                      Well, isn’t that the whole point? To get insights, the
                      examiner portal gives you the ideal data dashboard that
                      visualizes data to provide you with in depth learner
                      analytics that will help you evaluate the gaps in skills
                      and competencies of your work force. This tool will take
                      your training needs analysis to another level!
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="player" data-aos="fade-left" data-aos-duration="1500">
                  <img src={EXM1} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content-reverse">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5" >
                <div className="player" data-aos="fade-right" data-aos-duration="1500">
                  <img src={EXM2} alt="" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-left" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Remote Proctoring Services</h2>
                    <p>
                      An examination is only as effective as its execution, and
                      we have the perfect solution! The remote proctoring
                      feature offers capabilities such as learner
                      authentication, comprehensive proctoring technology, and a
                      secure exam browser that disables other tabs on the
                      learner’s screen.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-right" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Intuitive User Experience</h2>
                    <p>
                      Our team of experienced UI/UX designers have carefully
                      crafted our online and offline examination platforms for
                      user-friendliness. Whether accessing exams remotely or
                      offline, our interface ensures easy navigation. With our
                      examination module, no prior knowledge of SaaS-based
                      products is required; it's as simple as clicking on a
                      link.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="player" data-aos="fade-left" data-aos-duration="1500">
                  <img src={EXM3} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content-reverse">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5">
                <div className="player" data-aos="fade-right" data-aos-duration="1500">
                  <img src={EXM4} alt="" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-left" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Easy Exam Scheduler</h2>
                    <p>
                      The exam scheduler has been designed to bring all your
                      scheduled exams on a single dashboard, giving you easy and
                      simple access,
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-right" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>
                      Elevate Exam Creation with the Fidus Examiner Portal
                    </h2>
                    <p>
                      Crafting effective exams has never been easier. Choose
                      from a variety of question formats, including
                      multiple-choice, Drag and Drop, and descriptive questions.
                      With convenient features like bulk uploader, creating and
                      managing your question repository is a breeze.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="player" data-aos="fade-left" data-aos-duration="1500">
                  <img src={EXM5} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Examiner;
